import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './AppHeader.css';

function AppHeader({ onMenuClick }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Get page title from current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('focus') || path === '/app') return 'Focus';
    if (path.includes('flashes')) return 'Focus Flashes';
    if (path.includes('goals')) return 'Goals';
    if (path.includes('analytics')) return 'Analytics';
    if (path.includes('community')) return 'Community';
    if (path.includes('fiona')) return 'Focus Fiona';
    if (path.includes('settings')) return 'Settings';
    return 'Focus App';
  };

  return (
    <header className={`app-header ${isScrolled ? 'app-header-scrolled' : ''}`}>
      <div className="app-header-content">
        <button
          className="app-header-menu-btn"
          onClick={onMenuClick}
          aria-label="Toggle menu"
          title="Toggle navigation menu"
        >
          <span className="menu-icon">☰</span>
        </button>
        
        <h1 className="app-header-title">{getPageTitle()}</h1>
        
        <div className="app-header-actions">
          {/* Placeholder for future actions (notifications, profile, etc.) */}
        </div>
      </div>
    </header>
  );
}

export default AppHeader;
